import CoreModule from "modules/Core/core-modules/CoreModule";
import { AUTH } from "./consts";
import cells from "./state";
import Login from "./components/screens/Login";
import Register from "./components/screens/Register";
import Logout from "./components/screens/Logout";
import AccountSettings from "./components/screens/AccountSettings";
import OnLoad from "./components/OnLoad";
import { getToken } from "modules/Core/utils/auth";

export default new CoreModule({
  name: AUTH,
  initialState: {
    isAuthenticated: getToken() ? null : false,
    isAuthenticating: true
  },
  cells: {

    login: cells.login,
    register: cells.register,
    validateToken: cells.validateToken,
    logout: cells.logout,
  },
  routes: {
    "login": Login,
    "register": Register,
    "logout": Logout,
    "settings": AccountSettings,
  },
  rootRender: () => <OnLoad />

});
